import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { appRoutes } from '../app/routes.constant';
import { AuthGuard } from './auth/auth.guard';
import { HelpComponent } from './components/help/help.component';

export const routesArr: Routes = [
  { path: appRoutes.HELP, component: HelpComponent, canActivate: [AuthGuard]}
];

@NgModule({
  imports: [ RouterModule.forChild(routesArr) ],
  exports: [ RouterModule ]
})
export class DvpsCoreRoutingModule {}